import C from "../constants";
const subscription = (state = null, action) => {
  switch (action.type) {
    case C.SET_SUBSCRIPTION:
      return action.payload;
    default:
      return state;
  }
};
export default subscription;
